import styled from 'styled-components';
import { Card, ToggleButton as ConstellationToggleButton } from '@zillow/constellation';

export const Container = styled(Card)`
  width: 100%;
  max-width: 800px;
  margin: auto;
`;

export const ToggleButton = styled(ConstellationToggleButton)`
  @media (max-width: 649px) {
    padding-top: 12px !important;
    padding-bottom: 12px !important;
  }
`;

export const OutputsContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: 24px;

  @media (max-width: 649px) {
    flex-direction: column;
    padding-top: 0px;
  }
`;

export const OutputsPairContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;

  :first-of-type {
    padding-right: 24px;
  }

  @media (max-width: 649px) {
    padding-top: 24px;

    :first-of-type {
      padding-right: 0px;
    }
  }
`;
